import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';



@Component({
    selector: 'div.dtf-fawlogin',
    imports: [SharedTranslateModule],
    templateUrl: './fawlogin.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})

export class FawLoginComponent implements OnInit {
    title = 'FawLogin';
    router: Router;
    usUrl: string;
    source: string;
    agentId: string;
    language = '';
    authToken: string;
    identifier: string;
    brandId: string;
    serviceErrorOccurred = false;
    serviceErrorDesc = '';

    isAuthenticated = false;
    constructor(
        router: Router,
        public auth: AuthorizationService,
        private _window: WindowRef, public translate: TranslateService

        ) {
            this.router = router;
            this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    }
    ngOnInit() {
      sessionStorage.clear(); //clears all sessionStorage Objects
      this.source = (this._window.nativeWindow as any).mbfs.source;
      this.agentId = (this._window.nativeWindow as any).mbfs.agentId;
      this.authToken = (this._window.nativeWindow as any).mbfs.authToken;
      this.identifier = (this._window.nativeWindow as any).mbfs.identifier;
      this.language = (this._window.nativeWindow as any).mbfs.language;
      const fawDataRequest = {
        'source' : this.source,
        'agentId' : this.agentId,
        'authToken' : this.authToken,
        'identifier' : this.identifier
        };
      this.fawLoginCall(fawDataRequest);
    }

    fawLoginCall(fawDataRequest){
      this.auth.decryptFawToken(fawDataRequest).subscribe(res => {
        JSON.stringify(res);
        if (res.userValid === true && res.token !== null){
          sessionStorage.setItem("username", res.userId);
          this.auth.getAuthToken().subscribe(authRes=> {
            sessionStorage.setItem("Authorization", authRes.token);
            sessionStorage.setItem("userId", authRes.userId);

          this.brandId = res.brandId.toString();
          sessionStorage.setItem('auth', 'yes');
          this.auth.istoken = res.token;
          sessionStorage.setItem('loginID', res.userId);
          sessionStorage.setItem('agentview','true');
          sessionStorage.setItem('agentID', res.agentId);
          sessionStorage.setItem('ciamToken', this.auth.istoken);
          sessionStorage.setItem('brandId', this.brandId);
          sessionStorage.setItem('classicredirect', 'no');
          sessionStorage.setItem('forward', res.forward);
          sessionStorage.setItem('thirdPartyNumber', res.thirdPartyNumber);
          sessionStorage.setItem('customerName',res.customerName);
          sessionStorage.setItem('emailAddress',res.emailAddress);
          sessionStorage.setItem('loginID', res.userId);

          this.auth.isAuthenticated(); // Checks if user is authenticated
          if (this.brandId === '2') {
            this._window.nativeWindow.location.href = this.usUrl + '/home/dashboard';
          }
          else if (this.brandId === '3') {
            this._window.nativeWindow.location.href = this.usUrl + '/ca/en/home/dashboard';
          }
          else{
            this._window.nativeWindow.location.href = this.usUrl + '/home/dashboard';
          }
        });
         } else if (res.userValid === false && res.token === null) {
          this.translate.get('Errors.faw_AuthorizedError').subscribe((data: any) => {
            this.serviceErrorDesc = data;
           });
          this.serviceErrorOccurred = true;
        } else {
         // If checks to load BE error messages based on language
          if (this.language === 'en-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_EN;
          } else if (this.language === 'fr-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_FR;
          } else {
            this.serviceErrorDesc = res.status.message.shortMessage;
          }
          this.serviceErrorOccurred = true;
        }
      });
    }
}
